import { Location } from '@angular/common';
import {
    AfterViewInit,
    ChangeDetectorRef,
    Component,
    EventEmitter,
    HostBinding,
    OnDestroy,
    ViewRef
} from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import {
    NavigationCancel,
    NavigationEnd,
    NavigationError,
    NavigationStart,
    Router
} from '@angular/router';
import {
    EcapEsignatureService,
    EcapLoginService,
    EcapTranslateService,
    getCurrentLanguage as GetCurrentLanguage,
    LanguageAction,
    NotificationService,
    ShellDomainProvider,
    State,
    UserInfoService
} from '@ecap3/core';
import { SignalrNotificationService } from '@ecap3/signalr-notification';
import {
    FuseConfigService,
    FuseMatSidenavHelperService,
    FuseSidebarService,
    TemplateAtlasSharedService,
    ToolbarTriggerService
} from '@ecap3/template-atlas';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { forEach } from 'lodash';
import { Observable, Subject } from 'rxjs';
import { take, takeUntil } from 'rxjs/operators';
import { IMessageNotificationDenomData } from 'src/app/business/app-chat/interfaces/chat-panel.interface';
import { NOTIFICATION_KEYS } from 'src/app/delta-config/constant/notification-keys.constant';
import { CustomNotificationService } from 'src/app/root/service/custom-notification.service';
import { ToolbarEventManagerService } from '../../root/service/toolbar-event-manager.service';
import { OfflineNotificationService } from '../../shared/services/offline-notification.service';
import { SharedService, ToolbarColor } from '../../shared/services/shared.service';
@Component({
    selector: 'toolbar',
    templateUrl: './toolbar.component.html',
    styleUrls: ['./toolbar.component.scss']
})
export class SLSNToolbarComponent implements AfterViewInit, OnDestroy {
    language = new Subject<string>();
    lang$: Observable<string>;
    @HostBinding('class.is-preview-open') isPreviewOpen;
    @HostBinding('class.is-preview-close') isPreviewClose;

    toolbarBackgroundColor = '#FFFFFF';
    toolbarIconColor = '#141414';

    botImage =
        ShellDomainProvider['api'] &&
        ShellDomainProvider['api']['CdnTenantBaseUrl'] +
            'assets/images/bot_three.svg';
    logo: string;
    userStatusOptions: any[];
    languages: any;
    selectedLanguage: any;
    loading: boolean;
    horizontalNav: boolean;
    newNotificationUpdate = new EventEmitter<any>();
    numberOfUnreadMessage = 0;
    newNotificationArrived: boolean; // checking if new notificaiton arrived
    checkNewNotification = new EventEmitter<any>();
    selectAssistantActiveThreadId: string;
    floatingPanelActiveThreadId: string;
    customerCreateMessage = '';
    customerUpdateMessage = '';
    activityEventMessage = '';
    customerDocumentMessage = '';
    languageList = [
        {
            id: 'en',
            title: 'English',
            flag: 'us'
        },
        {
            id: 'de',
            title: 'German',
            flag: 'de'
        },
        {
			id: 'it',
			title: 'ITALIAN',
			flag: 'it',
		},
    ];
    notificationCounter = 0;
    fuseConfig: any;
    toolbarData = null;

    private _unsubscribeAll: Subject<any>;

    contactPersons = null;
    personsLoading = true;

    constructor(
        private location: Location,
        private router: Router,
        private matSnackbar: MatSnackBar,
        private ecapTranslateService: EcapTranslateService,
        private translationService: TranslateService,
        private store: Store<State>,
        public _fuseConfigService: FuseConfigService,
        private loginService: EcapLoginService,
        public toolbarTriggerService: ToolbarTriggerService,
        private signalrNotificationService: SignalrNotificationService,
        private notificationService: NotificationService,
        public sharedService: TemplateAtlasSharedService,
        private userInfo: UserInfoService,
        private _fuseSidebarService: FuseSidebarService,
        private matSidebarHelper: FuseMatSidenavHelperService,
        private ecapEsignatureService: EcapEsignatureService,
        private chageDetection: ChangeDetectorRef,
        private customSharedService: SharedService,
        private toolbarEventService: ToolbarEventManagerService,
        private offlineNotificationService: OfflineNotificationService,
        private _customNotificationService: CustomNotificationService
    ) {
        this.lang$ = this.store.select(GetCurrentLanguage);
        this._unsubscribeAll = new Subject();

        this.userStatusOptions = [
            {
                title: 'Online',
                icon: 'icon-checkbox-marked-circle',
                color: '#4CAF50'
            },
            {
                title: 'Away',
                icon: 'icon-clock',
                color: '#FFC107'
            },
            {
                title: 'Do not Disturb',
                icon: 'icon-minus-circle',
                color: '#F44336'
            },
            {
                title: 'Invisible',
                icon: 'icon-checkbox-blank-circle-outline',
                color: '#BDBDBD'
            },
            {
                title: 'Offline',
                icon: 'icon-checkbox-blank-circle-outline',
                color: '#616161'
            }
        ];

        this.prepareDisplayLanguage();

        this.router.events
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe({
                next: (event: any) => {
                    switch (true) {
                        case event instanceof NavigationStart: {
                            this.loading = true;
                            break;
                        }
                        case event instanceof NavigationEnd:
                        case event instanceof NavigationCancel:
                        case event instanceof NavigationError: {
                            this.loading = false;
                            break;
                        }
                        default: {
                            break;
                        }
                    }
                }
            });

        this._fuseConfigService.config.pipe().subscribe({
            next: (settings) => {
                this.fuseConfig = settings;
                this.horizontalNav = settings.layout.navbar.position === 'top';
            }
        });

        // =================================================
        // checking if there is new notification arrived
        // =================================================
        this.checkNewNotification
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe({
                next: (response: any) => {
                    if (
                        response.ThreadId !==
                            this.selectAssistantActiveThreadId &&
                        response.ThreadId !== this.floatingPanelActiveThreadId
                    ) {
                        this.notificationService
                            // .getUnreadNotificationCounter()
                            .getUnreadNotificationCountByFilter(NOTIFICATION_KEYS,true)
                            .pipe(takeUntil(this._unsubscribeAll))
                            .subscribe({
                                next: (counter) => {
                                    this.newNotificationUpdate.emit(counter);
                                }
                            });
                    } else {
                        this.sharedService.reshufleNotification(
                            response.ThreadId
                        );
                    }
                },
                error: (error: any) => {
                    console.log(error);
                }
            });
        // =====================================================
        // subscribing for new notification counter
        // =====================================================
        this.newNotificationUpdate
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe({
                next: (counter) => {
                    this.unreadNotificationCount = counter;
                    this.sharedService.notifyNewUnreadMessage(0, 10, true);
                    // this.numberOfUnreadMessage = counter;
                    this.updateCounter(counter);
                    if (!(<ViewRef>this.chageDetection).destroyed) {
                        this.chageDetection.detectChanges(); // important feature for live update of chat field : this is must
                    }
                }
            });
        this.sharedService.getCounter();
        // ======================================================
        // update counter after notification marked as read
        // ======================================================
        this.sharedService.notificationMarkRead
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe({
                next: (result: any) => {
                    this.updateCounter(result);
                    if (!(<ViewRef>this.chageDetection).destroyed) {
                        this.chageDetection.detectChanges(); // important feature for live update of chat field : this is must
                    }
                }
            });
        // ================================================
        // signalrNotification integration
        // ================================================

        // storing references for using inside signalr callback function
        const notification = this.notificationService;
        const newNotificationUpdate = this.newNotificationUpdate;
        const replicasharedService = this.sharedService;
        // const checkNotification = this.checkNewNotification;
        const customNotificationService = this._customNotificationService;
        // const platformchatService = this.platformChatService;
        // storing references for using inside signalr callback function ends

        // updating select assistant current threadId
        this.sharedService.updatedSelectAssistantThreadId
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe({
                next: (response: any) => {
                    this.selectAssistantActiveThreadId = response;
                }
            });
        // updating floating panel current threadId
        this.sharedService.updatedFloatingPanelThreadId
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe({
                next: (response: any) => {
                    this.floatingPanelActiveThreadId = response;
                }
            });

        // this.offlineNotificationService.responseKeyCollection.forOf(key=>{
        //     this.signalrNotificationService.registerBroadcast(
        //         key,
        //         function (response) {
        //             console.log('registerNotificationService', response);
        //             notification
        //                 .getUnreadNotificationCounter()
        //                 .subscribe((counter) => {
        //                     console.log('notification Counter', counter);
        //                     newNotificationUpdate.emit(counter);
        //                     replicasharedService.newNotificationArrived.emit(true);
        //                 });
        //         }
        //     );
        // })

        // ==============================
        // Chat Notification Subscription
        // ==============================

        this.signalrNotificationService.registerBroadcast(
            'MessagingThreadNotification',
            function (response) {
                if (response.denormalizedMessage) {
                    replicasharedService.sendNewArrivedMessageToChatBox(
                        response.denormalizedMessage
                    );
                }
                // notification.getUnreadNotificationCounter().subscribe((counter) => {
                //     newNotificationUpdate.emit(counter);
                // });
            }
        );

        this.signalrNotificationService.registerBroadcast(
            'ThreadRecipientsUpdated',
            function (response) {
                if (response.denormalizedMessage) {
                    customNotificationService.onthreadRecipientsUpdated(
                        response.denormalizedMessage
                    );
                    console.log('Chat Thread Recipients Updated');
                    notification
                        // .getUnreadNotificationCounter()
                        .getUnreadNotificationCountByFilter(NOTIFICATION_KEYS,true)
                        .subscribe({
                            next: (counter) => {
                                newNotificationUpdate.emit(counter);
                                replicasharedService.newNotificationArrived.emit(
                                    true
                                );
                            }
                        });
                }
            }
        );

        //ThreadRecipientsUpdated

        for (const responseKey in this.offlineNotificationService
            .responseKeyCollection) {
            if (isNaN(Number(responseKey))) {
                this.signalrNotificationService.registerBroadcast(
                    responseKey,
                    function (response) {
                        notification
                            // .getUnreadNotificationCounter()
                            .getUnreadNotificationCountByFilter(NOTIFICATION_KEYS,true)
                            .subscribe({
                                next: (counter) => {
                                    newNotificationUpdate.emit(counter);
                                    replicasharedService.newNotificationArrived.emit(
                                        true
                                    );
                                }
                            });
                    }
                );
            }
        }

        this.subscribeEventAfterUserLoad();

        // ================================================
        // signalrNotification integration ends
        // ================================================

        // ===============================================
        // getting all unread notifications on first load
        // ===============================================
        this.getAllUnreadNotificationOnInitialLoad();

        // ===============================================
        // when new notificaiton arrives
        // ===============================================
        this.sharedService.newNotificationArrived
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe({
                next: (response) => {
                    this.newNotificationArrived = response;
                    setTimeout(() => {
                        this.newNotificationArrived = false; // resetting again for next use
                        if (!(<ViewRef>this.chageDetection).destroyed) {
                            this.chageDetection.detectChanges(); // important feature for live update of chat field : this is must
                        }
                        // this.notificationCounter = this.sharedService.getCounter();
                    }, 500);
                }
            });

        this.subscribeToolbarColorChange();

        this.subscribeToNewMessageArrival();
    }

    subscribeToNewMessageArrival() {
        this.signalrNotificationService.registerBroadcast(
            'MessagingThreadNotification',
            (response) => {
                if (response.denormalizedMessage) {
                    this.sharedService.sendNewArrivedMessageToChatBox(
                        response.denormalizedMessage
                    );
                }
                // notification.getUnreadNotificationCounter().subscribe((counter) => {
                //     newNotificationUpdate.emit(counter);
                // });
            }
        );
    }

    private getTranslation() {
        this.customerCreateMessage =
            this.translationService.instant('SHARED.SHARED_TEXT');
        console.log(this.customerCreateMessage);
        this.activityEventMessage = this.translationService.instant(
            'SYNC_ACTIVITY_EVENT_MESSAGE'
        );
        this.customerUpdateMessage = this.translationService.instant(
            'KVV_CUSTOMER_UPDATE_MESSAGE'
        );
        this.customerDocumentMessage = this.translationService.instant(
            'SYNC_MEETING_DOCUMENT_MESSAGE'
        );
    }

    private subscribeToolbarColorChange() {
        this.customSharedService.toolbarColorEvent
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe({
                next: (res: ToolbarColor) => {
                    if (res) {
                        this.toolbarBackgroundColor = res.backgroundColor;
                        this.toolbarIconColor = res.iconColor;
                    }
                    console.log(res);
                }
            });
    }

    private showMessageOnSnakeBar(message: string) {
        this.matSnackbar.open(message, null, {
            duration: 2000,
            verticalPosition: 'top',
            horizontalPosition: 'end',
            panelClass: 'custom-snackbar'
        });
    }

    // on component destroy setting counter to zero
    ngOnDestroy() {
        this.sharedService.setCounter(0);

        this._unsubscribeAll.next(null as any);
        this._unsubscribeAll.complete();
    }

    updateCounter(counter) {
        this.sharedService.setCounter(counter); // then setting counter to actual number
    }

    setSelectedLanguage(langKey) {
        this.selectedLanguage = langKey;
    }

    public changeLang(langKey) {
        const message = JSON.stringify({
            action: 'languageSelection',
            data: {
                languageKey: langKey 
            }
        });
        if ((window as any).FlutterBridge) {
            console.log("[languageSelection] FlutterBridge detected.");
            (window as any).FlutterBridge.postMessage(message);
        }
        this.language.next(langKey);
        this.selectedLanguage = langKey;
        this.setLangCookie(langKey);
        this.ecapTranslateService.changeLanguage(langKey);
    }

    prepareDisplayLanguage() {
        if (
            ShellDomainProvider['api'].language &&
            ShellDomainProvider['api'].language.length
        ) {
            ShellDomainProvider['api'].language.forEach((element) => {
                element['title'] = element['title'].toUpperCase();
            });
        }

        this.languages = this.languageList;
    }

    public logout() {
        console.log('logging out...');
        this.loginService.logoutFromPlatform();
    }

    ngAfterViewInit() {
        const nsWebViewBridge = (window as any).nsWebViewBridge;
        // nsWebViewBridge.on('reconnectWebSocket', (msg: any) => {
        //     console.log('[toolbar] reconnectWebSocket event triggered from webview');
        //     console.log("[toolbar] message found: ", msg);
        //     this.customSharedService.sendChatInboxCloseEvent();
        //     this.customSharedService.reconnectWebSocket();
        //     console.log("[toolbar] reconnet event passed in chat panel msg view component");
        //     this.signalrNotificationService.reconnect();
        //     console.log("[toolbar] webSocket reconnected");
        // });
    }
    public setLangCookie(lang) {
        document.cookie = `langKey=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;`;
        document.cookie = `langKey=${lang}; Path=/`;
    }

    unreadMessageCount = 0;
    unreadNotificationCount = null;

    ngOnInit() {
        this.language.subscribe({
            next: (lang) => {
                this.store.dispatch(new LanguageAction(lang));
                this.selectedLanguage = lang;
            }
        });
        this.lang$.subscribe({
            next: (lang) => {
                this.selectedLanguage = lang;
                this.translationService.use(lang);
            }
        });
        this.getTranslation();
        // this.selectedLanguage = this.translationService.getTranslate().currentLang;

        TemplateAtlasSharedService.getChangePreview()
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe({
                next: (data) => {
                    this.isPreviewOpen = data;
                }
            });

        this.customSharedService.toolbarSubject
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe({
                next: (data: { title: string; route: string }) => {
                    console.log(data);
                    this.toolbarData = data;
                }
            });

        this.customSharedService.contactPersonsSubject
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe({
                next: (data) => {
                    console.log('toolbar contact persons: ', data);
                    this.contactPersons = data;
                }
            });

        // listen to chat inbox close
        this.customSharedService.chatInboxCloseSubject
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe({
                next: (resp: any) => {
                    this.updateUnreadMessageCount();
                }
            });
        this.updateUnreadMessageCount();

        // listen to new message arrival
        this.sharedService.messageArrived
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe({
                next: (newMessageDenomView: string) => {
                    const newMessage = JSON.parse(newMessageDenomView) as IMessageNotificationDenomData;
                    console.log("[toolbar] new msg arrived");
                    
                    this.updateUnreadMessageCount();
                }
            });

            this._customNotificationService.unreadMessageCount$
                .pipe(takeUntil(this._unsubscribeAll))
                .subscribe({
                    next: (unreadCount: number) =>
                        (this.unreadMessageCount = unreadCount)
                });
    }

    updateUnreadMessageCount(){
        setTimeout(()=>{
            this.notificationService.getUnreadNotificationCountByFilter(['MessagingThreadNotification'], true)
                .pipe(take(1))
                .subscribe({
                    next: (resp: any) => {
                        this.unreadMessageCount = resp;
                        this.chageDetection.detectChanges();
                        console.log("[toolbar] unreadMessageCount updated");
                    }
                });
        },500)
    }

    setDefaultLog() {
        this.logo =
            ShellDomainProvider['api'] &&
            ShellDomainProvider['api']['CdnTenantBaseUrl'] + 'arc2-logo.svg';
    }
    replacePlaceholderValues(text, valueObj) {
        forEach(valueObj, function (value, key) {
            if (value) {
                text = text.split('[' + key + ']').join(value);
            } else {
                text = text.split('[' + key + ']').join('');
            }
        });
        return text;
    }

    //Filter specific Subscription after user loaded
    subscribeEventAfterUserLoad() {
        const that = this;
        const _notification = this.notificationService;
        const _newNotificationUpdate = this.newNotificationUpdate;

        this.userInfo.currentUser
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe({
                next: (result: any) => {
                    if (result != 'DEFAULT_MESSAGE' && result != 'LOGOUT_MESSAGE') {
                        this.signalrNotificationService.registerBroadcast(
                            'ContactsExcelExportEvent',
                            (response) => {
                                console.log(response);
                                // NOTIFY_FOR_EXPORT_DONE
                                // NOTIFY_FOR_EXPORT_FAILURE
                                if (response) {
                                    const responseValue = JSON.parse(
                                        response.value
                                    );
                                    if (responseValue) {
                                        const message =
                                            this.translationService.instant(
                                                responseValue.Success
                                                    ? 'NOTIFY_FOR_EXPORT_DONE'
                                                    : 'NOTIFY_FOR_EXPORT_FAILURE'
                                            );
                                        that.matSnackbar.open(message, 'X', {
                                            // duration: 10000,
                                            panelClass: 'custom-snackbar',
                                            verticalPosition: 'top',
                                            horizontalPosition: 'end'
                                        });
                                    }
                                }
                            }
                        );
                        this.signalrNotificationService.registerBroadcast(
                            'Selise.Ecap.ESignature',
                            (response) => {
                                console.log('Notify in toolbar');
                                //this.getSummaryData(this.esignatureInfo);debugger;
                                this.ecapEsignatureService.triggerEvent(response);

                                if (response) {
                                    const responseValue = JSON.parse(
                                        response.value
                                    );
                                    console.log(responseValue);
                                }
                            }
                        );

                        const userRoles = this.userInfo.userInfo.Roles;
                    }
                }
            });
    }

    /**
     * Title: getAllUnreadNotificationOnInitialLoad
     * Description: getting all unread notifications on initial load
     * @param null
     * @return null
     */
    getAllUnreadNotificationOnInitialLoad(): void {
        this.userInfo.currentUser
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe({
                next: (result: any) => {
                    if (result != 'DEFAULT_MESSAGE' && result != 'LOGOUT_MESSAGE') {
                        this.notificationService
                            // .getUnreadNotificationCounter()
                            .getUnreadNotificationCountByFilter(NOTIFICATION_KEYS,true)
                            .pipe(takeUntil(this._unsubscribeAll))
                            .subscribe({
                                next: (counter) => {
                                    this.newNotificationUpdate.emit(counter);
                                }
                            });
                    }
                }
            });
    }

    /**
     * Title: getUserRole
     * Description: getting logged in users role
     * param null
     * return loggedin users role
     */
    public isAdminLoggedIn() {
        return (
            this.userInfo.userInfo.Roles.indexOf('admin') > -1 ||
            this.userInfo.userInfo.Roles.indexOf('admin_market') > -1
        );
    }

    public ToggleSidePanel() {
        // opening chat panel with filip assistant active in the panel
        // this.platformChatService.onNotificationPanelClicked.emit({
        //     ThreadId: null
        // });
    }

    public ToggleHouseholdSidePanel() {
        this.matSidebarHelper.getSidenav('customer-household').toggle();
    }

    /**
     * Toggle sidebar open
     *
     * @param key
     */
    toggleSidebarOpen(key): void {
        this._fuseSidebarService.getSidebar(key).toggleOpen();
    }

    chatIconClicked() {
        // this.customSharedService.chatIconClicked.next(true);
        this.router.navigate(['chats']);
    }

    notificationIconClicked() {
        // this.customSharedService.notificationIconClicked.next(true);
        this.offlineNotificationService.onNotificationBtnClicked.emit(true);
        // this.router.navigate(['notifications']);
		this._fuseSidebarService.getSidebar('quickPanel').toggleOpen();

    }

    goBack(): void {
        // this.customSharedService.sendToolbarData(null);
        // this.location.back();
        console.log(this.toolbarData.route, this.toolbarData.queryParam);
        
        if(this.toolbarData.title === 'PROJECT_DETAILS' && this.toolbarData.route !== 'schedule'){
            this.toolbarData.route = 'projects-wishlist';
        }
        if(this.toolbarData.title === 'Docs'){
            this.toolbarData.title = 'PROJECT_DETAILS';
        }
        this.router.navigate(
            [this.toolbarData.route],
            this.toolbarData.queryParam
        );
    }

    gotoHome() {
        this.router.navigate(['home']);
    }

    openBottomSheet(): void {
        // this.toolbarEventService.onAvatarClick.emit(true);
        this.toolbarEventService.onAvatarSubjectClick();
    }

    onKeyDown(event: KeyboardEvent): void {
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
        }
    }
}
